import { render } from "./my_installments.vue?vue&type=template&id=5d46337b"
import script from "./my_installments.vue?vue&type=script&lang=js"
export * from "./my_installments.vue?vue&type=script&lang=js"

import "./my_installments.vue?vue&type=style&index=0&id=5d46337b&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__